import React, { Component } from 'react'

export default class Skills extends Component {
    render() {
        return (
            <div>
                <div className="w3-container">
                    <p><i className="fa fa-briefcase fa-fw w3-margin-right w3-large w3-text-dark-grey"></i>Analista - Programador Web</p>
                    <p><i className="fa fa-home fa-fw w3-margin-right w3-large w3-text-dark-grey"></i>Caracas, Venezuela</p>
                    <p><i className="fa fa-envelope fa-fw w3-margin-right w3-large w3-text-dark-grey"></i>thaeron.vash@gmail.com</p>
                    <p><i className="fa fa-github fa-fw w3-margin-right w3-large w3-text-dark-grey"></i>github.com/thaeronm</p>
                    <p><i className="fa fa-phone fa-fw w3-margin-right w3-large w3-text-dark-grey"></i>+58-412-9005082</p>
                    <hr/>

                    <p className="w3-large"><b><i className="fa fa-asterisk fa-fw w3-margin-right w3-text-dark-grey"></i>Habilidades</b></p>
                    <p>Backend</p>
                    <div className="w3-light-grey w3-round-xlarge w3-small">
                        <div className="w3-container w3-center w3-round-xlarge w3-dark-grey" style={{width:'90%'}}>
                            <div className="w3-center w3-text-white">90%</div>
                        </div>
                    </div>
                    <p>BD</p>
                    <div className="w3-light-grey w3-round-xlarge w3-small">
                        <div className="w3-container w3-center w3-round-xlarge w3-dark-grey" style={{width:'80%'}}>
                            <div className="w3-center w3-text-white">80%</div>
                        </div>
                    </div>
                    <p>Frontend</p>
                    <div className="w3-light-grey w3-round-xlarge w3-small">
                        <div className="w3-container w3-center w3-round-xlarge w3-dark-grey" style={{width:'70%'}}>
                            <div className="w3-center w3-text-white">70%</div>
                        </div>
                    </div>
                    <p>Móvil</p>
                    <div className="w3-light-grey w3-round-xlarge w3-small">
                        <div className="w3-container w3-center w3-round-xlarge w3-dark-grey" style={{width:'60%'}}>
                            <div className="w3-center w3-text-white">60%</div>
                        </div>
                    </div>
                    <br/>
                    <p className="w3-large w3-text-theme"><b><i className="fa fa-globe fa-fw w3-margin-right w3-text-dark-grey"></i>Lenguajes de Programacion</b></p>
                    <p>JavaScript (Node, AdonisJS, NestJS, React, Angular)</p>
                    <div className="w3-light-grey w3-round-xlarge">
                        <div className="w3-round-xlarge w3-dark-grey" style={{height:'24px', width:'75%'}}></div>
                    </div>
                    <p>PHP (Laravel)</p>
                    <div className="w3-light-grey w3-round-xlarge">
                        <div className="w3-round-xlarge w3-dark-grey" style={{height:'24px', width:'100%'}}></div>
                    </div>
                    <p>Desarrollo Híbrido (React Native, ElectronJS, Ionic)</p>
                    <div className="w3-light-grey w3-round-xlarge">
                        <div className="w3-round-xlarge w3-dark-grey" style={{height:'24px', width:'50%'}}></div>
                    </div>
                    <br/>
                </div>
            </div>
        )
    }
}
